// take a look at https://github.com/lancedikson/bowser#browser-flags
// for potential browser type values (CM).
export type TBrowserTypes = 'chrome' | 'safari' | 'firefox' | 'msedge' | 'msie' | 'other';

export enum BrowserUpgradeStatus {
  FullButNotOptimized = 'FullButNotOptimized',
  MustUpdateOrSwitch = 'MustUpdateOrSwitch',
  MustSwitch = 'MustSwitch',
}

export interface IBrowserVersionsSupportedConfig {
  [key: string]: BrowserUpgradeStatus;
}

type TBrowserVersionsSupported = { [key in TBrowserTypes]: IBrowserVersionsSupportedConfig };

// browser versions should include one of the following:
// <, <=, >, >=, or 'All' (CM)
export const BROWSER_VERSIONS_SUPPORTED: TBrowserVersionsSupported = {
  chrome: {
    '<57': BrowserUpgradeStatus.MustUpdateOrSwitch,
  },
  safari: {
    '>=10.1': BrowserUpgradeStatus.FullButNotOptimized,
    '<10.1': BrowserUpgradeStatus.MustUpdateOrSwitch,
  },
  firefox: {
    '>=52': BrowserUpgradeStatus.FullButNotOptimized,
    '<52': BrowserUpgradeStatus.MustUpdateOrSwitch,
  },
  msedge: {
    '>=16': BrowserUpgradeStatus.FullButNotOptimized,
    '<16': BrowserUpgradeStatus.MustUpdateOrSwitch,
  },
  msie: {
    All: BrowserUpgradeStatus.MustSwitch,
  },
  other: {
    All: BrowserUpgradeStatus.MustSwitch,
  },
};

export const BROWSER_HUMAN_NAME = {
  chrome: 'Chrome',
  safari: 'Safari',
  firefor: 'Firefox',
  msedge: 'Edge',
  msie: 'IE',
  other: 'your browser', // for other browsers
};
